import { FiDownload, FiHeart, FiRepeat } from 'react-icons/fi';
import { Button } from './ui';
import { trackEvent } from '../utils/tracking';
const Header = ({
  activeView,
  setActiveView,
  currentView,
  totalViews,
  handleNext,
  handlePrevious,
  selectedSamples = [],
  onCheckout,
  handleRequestSampleClick,
  isSampleSelectionMode,
  likedCount = 0,
  onToggleLikedPanel,
  compareCount = 0,
  onToggleComparePanel,
  onDownload,
  onChangeRoom,
  layoutPicked = false,
  onMySpace,
}) => {
  const applicationAreas = ['Kitchens', 'Vanities', 'Wall-cladding'];

  // Detect mobile breakpoint
  const isMobile = window.innerWidth <= 768;

  return (
    <div className="header">
      {isMobile ? (
        <div className="header-mobile-wrapper">
          <div className="header-mobile-center">
            <div className="application-areas">
              {applicationAreas.map((area) => (
                <button
                  key={area}
                  className={`app-area-btn ${activeView === area ? 'active' : ''}`}
                  onClick={() => {
                    if (activeView !== area) {
                      trackEvent('surface_changed', { application: area });
                    }
                    setActiveView(area);
                  }}
                >
                  {area === 'Wall-cladding' ? 'Walls' : area}
                </button>
              ))}
            </div>
          </div>
          <div className="header-mobile-right">
            {onMySpace && (
              <button className="my-space-cta-btn my-space-cta-btn--mobile" onClick={onMySpace} title="Visualize your real space">
                ✦ My Space
              </button>
            )}
            <Button variant="outline" size="icon" className="compare-badge-btn-mobile" onClick={onToggleComparePanel} title="Compare Colors">
              <FiRepeat size={18} className={compareCount > 0 ? 'compare-icon-active' : ''} />
              {compareCount > 0 && <span className="compare-badge-count-mobile">{compareCount}</span>}
            </Button>
            <Button variant="outline" size="icon" className="liked-badge-btn-mobile" onClick={onToggleLikedPanel} title="Liked Visuals">
              <FiHeart size={18} className={likedCount > 0 ? 'liked-icon-active' : ''} />
              {likedCount > 0 && <span className="liked-badge-count-mobile">{likedCount}</span>}
            </Button>
            <Button variant="outline" size="icon" className="download-btn-mobile" onClick={onDownload} title="Download Visualization">
              <FiDownload size={18} />
            </Button>
          </div>
        </div>
      ) : (
        <>
          <div className="header-left">
            <div className="company-branding">
              <a href="https://www.elegantfittings.co.ke/" target="_blank" rel="noopener noreferrer" className="header-logo-link" title="Go to Elegant Fittings website">
                <img src="/Logo-01.png" alt="Elegant Fittings Logo" className="header-logo" />
              </a>
            </div>
            <div className="visualizer-title">
              <h1 className="main-title">VISUALIZER</h1>
              <p className="main-subtitle">Experience the luxury stone in your home</p>
              <a href="https://www.elegantfittings.co.ke/" target="_blank" rel="noopener noreferrer" className="header-home-link">elegantfittings.co.ke ↗</a>
            </div>
          </div>
          <div className="header-center">
            {layoutPicked && onChangeRoom && (
              <button className="header-change-room-btn" onClick={onChangeRoom} title="Browse all room layouts">
                ⊞ Change Room
              </button>
            )}
            <div className="application-areas">
              {applicationAreas.map((area) => (
                <button
                  key={area}
                  className={`app-area-btn ${activeView === area ? 'active' : ''}`}
                  onClick={() => {
                    if (activeView !== area) {
                      trackEvent('surface_changed', { application: area });
                    }
                    setActiveView(area);
                  }}
                >
                  {area}
                </button>
              ))}
            </div>
          </div>
          <div className="header-right">
            {onMySpace && (
              <button className="my-space-cta-btn" onClick={onMySpace} title="Visualize your real space with AI">
                ✦ Visualize My Space
              </button>
            )}
            <div className="navigation-controls">
              <Button variant="outline" size="icon" className="nav-arrow" onClick={handlePrevious}>
                &lt;
              </Button>
              <span className="view-counter">
                {currentView}/{totalViews}
              </span>
              <Button variant="outline" size="icon" className="nav-arrow" onClick={handleNext}>
                &gt;
              </Button>
            </div>
            <Button variant="outline" size="icon" className="compare-badge-btn" onClick={onToggleComparePanel} title="Compare Colors">
              <FiRepeat size={18} className={compareCount > 0 ? 'compare-icon-active' : ''} />
              {compareCount > 0 && <span className="compare-badge-count">{compareCount}</span>}
            </Button>
            <Button variant="outline" size="icon" className="liked-badge-btn" onClick={onToggleLikedPanel} title="Liked Visuals">
              <FiHeart size={18} className={likedCount > 0 ? 'liked-icon-active' : ''} />
              {likedCount > 0 && <span className="liked-badge-count">{likedCount}</span>}
            </Button>
            <Button variant="outline" size="icon" className="download-btn" onClick={onDownload} title="Download Visualization">
              <FiDownload size={20} />
            </Button>
            {selectedSamples.length > 0 && (
              <Button onClick={() => {
                trackEvent('checkout_click', {
                  source: 'header',
                  sample_count: selectedSamples.length
                });
                onCheckout();
              }}>
                Checkout
                <span className="checkout-count">{selectedSamples.length}</span>
              </Button>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default Header;
